export default __webpack_public_path__ + "static/media/appsyncschema.6a1701fb.png";